<div
  class="position-absolute h-100 w-100 spinner-overlay"
  [class.with-background]="withBackground"
  [class.centered]="centered"
>
  <div class="position-absolute top-50 start-50 translate-middle">
    <div class="loading fa fa-spinner fa-spin fa-3x"></div>
  </div>
</div>
